export default "__VITE_ASSET__BIX9xVIx__"